import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { get_all_suspects, delete_suspect } from "../../../services/api-service";
import { toast } from "react-toastify";
import { Search } from "lucide-react";
// Re-use your existing CSS if needed
import "../../edit-student/edit.css"; 
import { REACT_APP_API_URL, API_ROUTES } from "config/api-config";
export default function SuspectList() {
  const [suspects, setSuspects] = useState([]);
  const [filteredSuspects, setFilteredSuspects] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const history = useHistory();
  const base64Prefix = "data:image/png;base64";

  useEffect(() => {
    fetchSuspects();
  }, []);

  const fetchSuspects = async () => {
    try {
      const response = await get_all_suspects();
      setSuspects(response.data);
      setFilteredSuspects(response.data);
    } catch (error) {
      toast.error("Failed to fetch suspects");
    }
  };

  // Simple search filter
  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredSuspects(suspects);
      return;
    }
    const lowerQuery = searchQuery.toLowerCase();
    const filtered = suspects.filter(
      (s) =>
        s.full_name?.toLowerCase().includes(lowerQuery) ||
        s.suspect_id?.toLowerCase().includes(lowerQuery)
    );
    setFilteredSuspects(filtered);
  }, [searchQuery, suspects]);

  const handleDelete = async (suspect_id) => {
    if (!window.confirm(`Are you sure you want to delete suspect ${suspect_id}?`)) return;
    
    try {
      await delete_suspect(suspect_id);
      toast.success("Suspect deleted successfully");
      fetchSuspects(); // Refresh list
    } catch (error) {
      console.error("Error deleting suspect:", error);
      toast.error(error.response?.data?.detail || "Failed to delete suspect");
    }
  };

  const handleEdit = (suspect) => {
    // Navigate to an edit page (you will need to create EditSuspect.jsx if you want a dedicated edit screen)
    // Passing the suspect data via state
    history.push({
      pathname: `/admin/editSuspect/${suspect.suspect_id}`,
      state: { suspect }
    });
  };

  return (
    <main className="emotionContainer" style={{ padding: "20px" }}>
      <div style={{ width: "100%" }}>
        
        {/* Top Navbar / Search */}
        <div style={{ backgroundColor: "#f8f9fa", padding: "15px 20px", borderRadius: "8px", marginBottom: "20px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
            <Search size={20} style={{ color: "#666" }} />
            <h3 style={{ margin: 0, color: "#333" }}>Suspect Directory</h3>
          </div>
          <div>
            <input
              type="text"
              placeholder="Search by Name or Suspect ID..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ width: "100%", maxWidth: "400px", padding: "8px 12px", borderRadius: "6px", border: "2px solid #ddd" }}
            />
          </div>
        </div>

        {/* Suspects Table */}
        <table>
          <thead>
            <tr>
              <th>Image</th>
              <th>Date Added</th>
              <th>Suspect ID</th>
              <th>Full Name</th>
              <th>Email</th>
              <th>Contact No.</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
<tbody>
            {filteredSuspects.length > 0 ? (
              filteredSuspects.map((suspect) => (
                <tr key={suspect.suspect_id}>
                  <td className="es-th">
                    {/* 2. Change suspect.image to suspect.has_image */}
                    {suspect.has_image ? (
                      <img
                        /* 3. Point directly to the new backend image endpoint */
                        src={`${REACT_APP_API_URL}/suspects/image/master/${suspect.suspect_id}`}
                        width="60px"
                        height="60px"
                        alt="Suspect"
                        /* 4. Pass the URL to the modal instead of the base64 string */
                        onClick={() => setSelectedImage(`${REACT_APP_API_URL}/suspects/image/master/${suspect.suspect_id}`)}
                        style={{ cursor: "pointer", objectFit: "cover", borderRadius: "4px" }}
                      />
                    ) : (
                      <div style={{ width: "60px", height: "60px", backgroundColor: "#eee", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px", fontSize: "10px" }}>No Photo</div>
                    )}
                  </td>
                  <td>{suspect.created_at}</td>
                  <td><strong>{suspect.suspect_id}</strong></td>
                  <td>{suspect.full_name}</td>
                  <td>{suspect.email || "N/A"}</td>
                  <td>{suspect.mobile_no || "N/A"}</td>
                  <td>
                    <Button
                      onClick={() => handleEdit(suspect)}
                      style={{ backgroundColor: "#007bff", color: "white", border: "none", borderRadius: "4px", padding: "6px 12px" }}
                    >
                      Edit
                    </Button>
                  </td>
                  <td>
                    <Button
                      onClick={() => handleDelete(suspect.suspect_id)}
                      style={{ backgroundColor: "#dc3545", color: "white", border: "none", borderRadius: "4px", padding: "6px 12px" }}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={{ textAlign: "center", padding: "20px", color: "#999" }}>
                  No suspects found.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* 5. Update the Image Modal to render the URL directly */}
        {selectedImage && (
          <div
            onClick={() => setSelectedImage(null)}
            style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}
          >
            <img src={selectedImage} alt="Enlarged" style={{ maxWidth: "80%", maxHeight: "80%" }} />
          </div>
        )}

      </div>
    </main>
  );
}
